import Streams from './streams'
import Create from './create'

export default {
  Streams,
  Create
}


// WEBPACK FOOTER //
// ./src/views/live/weibo/index.js